import React from 'react'
import { Message } from './Message'

export const Empty: React.FC = () => <Message>Please, select a service to start.</Message>
